import { isExistent } from "src/utils/miscellaneous";

export interface VersionInfo {
  build: string | null;
  isDirty: boolean;
  hash: string;
  version: string;
}

export function getBuildIdentifier({
  build,
  isDirty,
  environment,
  hash,
  version,
}: VersionInfo & { environment: string }): string {
  const buildDetails = [
    build || "0",
    hash.substr(0, 7),
    isDirty ? "dirty" : null,
    environment,
  ];
  return `${version}+${buildDetails.filter(isExistent).join(".")}`;
}
